import { React, classNames, withStyles, StyledProps, CentricTheme } from '@api'
import { Card, CardContent, CardMedia, withTheme } from '@material-ui/core'

const styles = (theme: CentricTheme) => ({
  card:                 {
    width:  112,
    height: 84,
    cursor: 'pointer'
  },
  content:              {
    padding: '0'
  },
  media:                {
    height:         51,
    margin:         `${theme.spacing() * 2}px 0`,
    backgroundSize: 'contain'
  },
  '@keyframes loading': {
    '0%':   {backgroundColor: theme.colors.grey2},
    '20%':  {backgroundColor: theme.colors.grey3},
    '40%':  {backgroundColor: theme.colors.grey4},
    '60%':  {backgroundColor: theme.colors.grey5},
    '85%':  {backgroundColor: theme.colors.grey4},
    '100%': {backgroundColor: theme.colors.grey3}
  },
  loading:              {
    animationDuration:       `1s`,
    animationName:           `loading`,
    animationIterationCount: `infinite`,
    animationTimingFunction: 'ease-out'
  },
  diagonalLine:         {
    width:        134,
    height:       45,
    position:     'absolute',
    borderBottom: '3px solid #f0190a',
    transform:    'translateY(37px) translateX(0px) rotate(145deg)',
    top:          0,
    left:         0,
    zIndex:       2
  },
  inactive:             {
    opacity: 0.5
  }
})

interface MyProps extends StyledProps {
  image: string,
  labelcolor: string,
  label: string,
  raised?: boolean
  loading?: boolean
  onClick?: (e) => void
  active?: boolean
}

@(withStyles as any)(styles)
export class MediaOnlyCard extends React.Component<MyProps> {
  static defaultProps = {
    // Use default image url in future
    image:       'no-image',
    label:       'image',
    active:      true,
    reactivated: false
  }

  render() {
    const {classes, image, label, labelcolor, raised, loading, onClick, active} = this.props

    return (
      <div style={{position: 'relative'}}>
        {!active && <div className={classes.diagonalLine}/>}
        <Card className={`${classes.card} ${!active && classes.inactive}`} raised={raised} style={{
          zIndex:       1,
          borderBottom: `2px solid ${labelcolor}`,
          boxShadow:    `${!raised && 'none'}`
        }} onClick={onClick} title={label}>
          <CardContent className={`${classes.content} ${loading ? classes.loading : ''}`}>
            <CardMedia image={image} className={classes.media} style={{opacity: active ? 1 : 0.7}}/>
          </CardContent>
        </Card>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/MediaOnlyCard.tsx